import { render, staticRenderFns } from "./editreport.vue?vue&type=template&id=4975f819&scoped=true"
import script from "./editreport.vue?vue&type=script&lang=js"
export * from "./editreport.vue?vue&type=script&lang=js"
import style0 from "./editreport.vue?vue&type=style&index=0&id=4975f819&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975f819",
  null
  
)

export default component.exports